import { Component, OnInit, Input } from '@angular/core';
import { BlogPost } from 'src/app/models/blogpost';

@Component({
  selector: 'app-blog-post-tile',
  templateUrl: './blog-post-tile.component.html',
  styleUrls: ['./blog-post-tile.component.scss']
})
export class BlogPostTileComponent implements OnInit {
  @Input('post') post:BlogPost;

  constructor() { }

  ngOnInit() {
  }

}
